import { lazyWithRetries } from '@globals/lazyWithRetries'
import AppPaths from '@globals/paths'
import StandardPageLayout from '@layouts/standardPageLayout'
import RouteLoading from '@shared/routing/RouteLoading'
import { T } from '@transifex/react'
import { Suspense } from 'react'
import { RouteObject } from 'react-router'

export const MAX_ALBUM_PAGE_WIDTH = 900

const SpacesRoute = lazyWithRetries(() => import('./mySpaces'))
const ConfigureSpaceRoute = lazyWithRetries(() => import('./configureSpace'))
const SpaceRoute = lazyWithRetries(() => import('./space'))
const SpacePostRoute = lazyWithRetries(() => import('./space/viewSpacePost'))
const AlbumsRoute = lazyWithRetries(() => import('./albums'))
const AlbumRoute = lazyWithRetries(() => import('./album'))
const PhotoRoute = lazyWithRetries(() => import('./album/photo'))

const routes: RouteObject[] = [
  {
    path: AppPaths.tenant.spaces(),
    element: (
      <StandardPageLayout elementId="spacesRoute" maxWidth={1080} title={<T _str="Spaces" />}>
        <Suspense fallback={<RouteLoading />}>
          <SpacesRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
  {
    path: AppPaths.tenant.configureSpace(':spaceId?'),
    element: (
      <StandardPageLayout elementId="configureSpaceRoute" maxWidth={1080}>
        <Suspense fallback={<RouteLoading />}>
          <ConfigureSpaceRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
  {
    path: AppPaths.tenant.viewSpace(':spaceId?'),
    element: (
      <Suspense fallback={<RouteLoading />}>
        <SpaceRoute />
      </Suspense>
    ),
  },
  {
    path: AppPaths.tenant.viewSpacePost(':spaceId', ':postId'),
    element: (
      <StandardPageLayout elementId="viewSpacePost" maxWidth={600}>
        <Suspense fallback={<RouteLoading />}>
          <SpacePostRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
  {
    path: AppPaths.tenant.albums(':spaceId?'),
    element: (
      <StandardPageLayout elementId="albumsRoute" maxWidth={900} title={<T _str="Albums" />}>
        <Suspense fallback={<RouteLoading />}>
          <AlbumsRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
  {
    path: AppPaths.tenant.album(':spaceId?', ':albumId?'),
    element: (
      <StandardPageLayout elementId="albumRoute" maxWidth={MAX_ALBUM_PAGE_WIDTH}>
        <Suspense fallback={<RouteLoading />}>
          <AlbumRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
  {
    path: AppPaths.tenant.albumPhoto(':spaceId', ':albumId', ':photo'),
    element: (
      <StandardPageLayout elementId="albumRoute" maxWidth={700}>
        <Suspense fallback={<RouteLoading />}>
          <PhotoRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
]

export default routes
